import React, { useState } from "react";
import "../styles/feedback.scss";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import '../styles/gallery.scss'

const flyers = [
    {
        id: 1,
        image: require('../imgs/healing.jpeg'),
        title: "Sound & Soul Healing Journey",
        date: "12. Juli 2024",
        description: "Stimme freisetzen • Inneres Kind heilen"
    },
    // {
    //     id: 2,
    //     image: require('../imgs/healing.jpeg'),
    //     title: "Sound & Soul Healing Journey",
    //     date: "12. Juli 2024",
    //     description: "Stimme freisetzen • Inneres Kind heilen"
    // },

    // Hier können Sie weitere Flyer hinzufügen
];

const Gallery = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedImage, setSelectedImage] = useState(null);

    const openModal = (image) => {
        setSelectedImage(image);
        setIsModalOpen(true);
        document.body.style.overflow = 'hidden'; // Prevent scrolling
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setSelectedImage(null);
        document.body.style.overflow = 'unset'; // Restore scrolling
    };

    return (
        <div className="section kundenfeedback">
            <h2>Events</h2>

            <div className="flyers-grid">
                {flyers.map((flyer) => (
                    <div key={flyer.id} className="flyer-card">
                        {/* <div className="flyer-info">
                            <h3>{flyer.title}</h3>
                            <p className="flyer-date">{flyer.date}</p>
                            <p className="flyer-description">{flyer.description}</p>
                        </div> */}

                        <div className="flyer-image-container">
                            <img
                                src={flyer.image}
                                alt={flyer.title}
                                className="flyer-image"
                                onClick={() => openModal(flyer.image)}
                            />

                        </div>
                    </div>
                ))}
            </div>

            {/* Advanced Zoom Modal */}
            {isModalOpen && (
                <div className="zoom-modal" onClick={closeModal}>
                    <div className="zoom-modal-content" onClick={e => e.stopPropagation()}>
                        <button className="close-button" onClick={closeModal}>
                            ✕
                        </button>
                        <div className="zoom-instructions">
                            <div className="instruction-header">
                                Bedienung
                            </div>
                            <div className="instruction-list">
                                <div className="instruction-item">
                                    <div className="icon zoom">🔍</div>
                                    <span className="action">Mausrad</span>
                                    <span className="description">Zoomen</span>
                                </div>
                                <div className="instruction-item">
                                    <div className="icon drag">👆</div>
                                    <span className="action">Ziehen</span>
                                    <span className="description">Bewegen</span>
                                </div>
                                <div className="instruction-item">
                                    <div className="icon reset">⟲</div>
                                    <span className="action">Doppelklick</span>
                                    <span className="description">Reset</span>
                                </div>
                            </div>
                        </div>

                        <TransformWrapper
                            initialScale={1}
                            minScale={0.5}
                            maxScale={10}
                            wheel={{ step: 0.2 }}
                            pinch={{ step: 5 }}
                            doubleClick={{ mode: "reset" }}
                            limitToBounds={false}
                        >
                            <TransformComponent
                                wrapperClass="transform-wrapper"
                                contentClass="transform-content"
                            >
                                <img
                                    src={selectedImage}
                                    alt="Flyer Details"
                                    className="modal-image"
                                />
                            </TransformComponent>
                        </TransformWrapper>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Gallery;
